<template>
  <div>
    Development
    <Chat :activator="[{ feature: 'classroom', id: 'ck1234567890' }]" />
    View all Flatmap <button @click="getFlatmap">Get Flatmap</button>
    {{ flatmap }}
  </div>
</template>

<script>
export default {
  components: {
    Chat: () => import("@/views/developing/components/chat")
  },
  data() {
    return {
      flatmap: []
    }
  },
  methods: {
    getFlatmap() {
      this.flatmap = Array.from(this.$flatmap.entries()).reduce((main, [key, value]) => ({...main, [key]: value}), {});
    }
  }
}
</script>

<style>

</style>